import { useContext } from 'react';
import { AuthContext } from '../../AuthContext';

const ChooseProgramModal = ({ 
    organizationPrograms,
    setCurrentProgram,
    setShowChooseProgramModal,    
    demoPrograms,
    setShowCreateProgramModal,
    setShowSignupModal,
    // setProgramToModify,
    membershipDetails,
    currentProgram,
    setShowPaywallModal,
    setShowManageProgramModal
    }) => {

    const { authUser } = useContext(AuthContext);

    const handleCreateNewProgramButtonClicked = () => {
        if (authUser) {            
            const maxPrograms = membershipDetails ? 5 : 1;
            
            if (organizationPrograms.length < maxPrograms) {
                setShowChooseProgramModal(false);
                setShowCreateProgramModal(true);
            } else {
                // alert(`You have reached the maximum number of programs (${maxPrograms}) for your organization. Please upgrade your membership to add more programs.`);                
                setShowChooseProgramModal(false);
                setShowPaywallModal(true);
            }
        } else {
            alert("Please login or signup to create a new program.");
            setShowChooseProgramModal(false);
            setShowSignupModal(true);
        }        
    }

    return (
        <div 
            className="modal-overlay" 
            style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
            onClick={() => setShowChooseProgramModal(false)}
        >
            <div 
                className="modal p-4 sm:p-6 lg:p-8 overflow-auto max-h-full mx-4 sm:mx-0" 
                style={{ 
                    cursor: 'default', 
                    width: '95vw',
                    maxWidth: '500px',
                    minHeight: '60vh',
                    maxHeight: '90vh',
                    backgroundColor: 'white', 
                    borderRadius: '10px'
                }}
                onClick={(e) => e.stopPropagation()} // Prevent click event from propagating to the overlay
            >
                <div className='flex flex-col gap-3 sm:gap-4'>
                    <p className='text-xl sm:text-2xl font-bold'>Your Grant Seeking Programs</p>                                                                
                    {organizationPrograms.map((program) => (
                        <div 
                            className={`flex flex-col sm:flex-row justify-between cursor-pointer items-start sm:items-center hover:bg-gray-100 p-3 sm:p-2 rounded-md gap-2 sm:gap-0 ${
                                currentProgram && currentProgram.id === program.id ? 'bg-indigo-50 border border-indigo-200' : ''
                            }`}
                            key={program.id}
                            onClick={() => {
                                setCurrentProgram(program);
                                setShowChooseProgramModal(false);
                            }}
                        >
                            <p className={`text-left text-sm sm:text-base break-words flex-1 ${
                                currentProgram && currentProgram.id === program.id ? 'font-semibold text-indigo-700' : ''
                            }`}>{program.programName}</p>
                            <button 
                                className='bg-gray-200 text-gray-500 text-xs px-3 py-1 sm:px-4 sm:py-2 hover:bg-gray-300 rounded-md self-end sm:self-auto' 
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent triggering the parent onClick                                    
                                    setCurrentProgram(program);
                                    setShowChooseProgramModal(false);
                                    setShowManageProgramModal(true);
                                }}
                            >Manage</button>
                        </div>
                    ))}
                    <div className='flex flex-row justify-between items-center'>
                        <button 
                        className='bg-indigo-500 text-white hover:bg-indigo-600 w-full text-left px-4 py-3 rounded-md text-sm sm:text-base' 
                        onClick={() => {
                            handleCreateNewProgramButtonClicked();                            
                        }}>+ Create New Program</button>
                    </div>

                    
                    {!authUser && (
                        <>
                            <p className='text-xl sm:text-2xl font-bold mt-4'>Demo Programs</p>
                            {demoPrograms.map((demoProgram) => (
                                <div className={`flex flex-col sm:flex-row justify-between items-start sm:items-center hover:bg-gray-100 p-3 sm:p-2 rounded-md ${
                                    currentProgram && currentProgram.programName === demoProgram.programName ? 'bg-indigo-50 border border-indigo-200' : ''
                                }`}
                                    key={demoProgram.programName}
                                    onClick={() => {
                                        setCurrentProgram(demoProgram);
                                        setShowChooseProgramModal(false);
                                    }}
                                >
                                    <p className={`text-sm sm:text-base break-words flex-1 ${
                                        currentProgram && currentProgram.programName === demoProgram.programName ? 'font-semibold text-indigo-700' : ''
                                    }`}>{demoProgram.programName}</p>
                                    
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ChooseProgramModal;